import React, {FunctionComponent} from "react";
import {CheckIcon} from "@App/Components/common/Icons";
import {
    PremiumServiceIsCollectAndReturnId, PremiumServiceIsReplacementVehicleId,
    ServiceIsGlass
} from "@App/utils/conditionals/services";
import {
    OrganizationIsLeaseplanAndServiceIsGaragesnearby, OrganizationIsNotDBConnectAndServiceIsVehicleReturn,
    ServiceIsGlassAndGarageHasNationwideService,
    ServiceIsVehicleReturnAndGarageIsDrivinLicenseCheckpoint
} from "@App/utils/conditionals/combinations";
import {
    GarageHasPremiumServicesVisibleInList,
    PremiumServiceIsAllowedInlist
} from "@App/utils/conditionals/premiumServices";
import {Garage, Organization, Service} from "@App/types";
import {useTranslation} from "react-i18next";
import {OrganizationIsArval} from "@App/utils/conditionals/organization";

type GarageListItemPremiumServicesProps = {
    service: Service
    garage: Garage
    organization: Organization
};

export const GarageListItemPremiumServices: FunctionComponent<GarageListItemPremiumServicesProps> = (props: GarageListItemPremiumServicesProps) => {

    const {t} = useTranslation()

    return (
        <div className={'relative'}>
            {ServiceIsGlass(props.service) && (
                <div
                    className={`flex items-center mb-3`}>
                    <CheckIcon primary/>
                    <div className="ml-1">
                        {t('listHints.glasRepair')}
                    </div>
                </div>
            )}
            {ServiceIsGlassAndGarageHasNationwideService(props.service, props.garage) && (
                <div
                    className={`flex items-center mb-3`}>
                    <CheckIcon primary/>
                    <div className="ml-1">
                        {t('listHints.mobileService')}
                    </div>
                </div>
            )}
            {ServiceIsVehicleReturnAndGarageIsDrivinLicenseCheckpoint(props.service, props.garage) && (
                <div
                    className={`flex items-center mb-3`}>
                    <CheckIcon primary/>
                    <div className="ml-1">
                        {props.garage.drivingLicenseCheckpoint.name}
                    </div>
                </div>
            )}
            {OrganizationIsLeaseplanAndServiceIsGaragesnearby(props.organization, props.service) && (
                <div
                    className={`flex items-center mb-3`}>
                    <CheckIcon primary/>
                    <div className="ml-1">
                        {t('listHints.callBacks')}
                    </div>
                </div>
            )}
            {OrganizationIsNotDBConnectAndServiceIsVehicleReturn(props.organization, props.service) && (
                <div
                    className={`flex items-center mb-3`}>
                    <CheckIcon primary/>
                    <div className="ml-1">
                        {t('listHints.leasingVehicleReturn')}
                    </div>
                </div>
            )}
            {GarageHasPremiumServicesVisibleInList(props.garage) && (
                <div className="font-bold">
                    {t('listHints.availableServicesListItemTitle', {organization: props.organization.name})}
                </div>
            )}
            {props.garage.premium_services && props.garage
                .premium_services
                .filter(PremiumServiceIsAllowedInlist)
                .map(premiumService => (
                    <div
                        className={`flex items-center mt-1`}
                        key={premiumService.name}>
                        <CheckIcon primary/>
                        <div className="ml-1 tooltipContainer">
                            {premiumService.name}
                            {(OrganizationIsArval(props.organization) && PremiumServiceIsCollectAndReturnId(premiumService)) &&(
                                <span className="tooltipContent hidden rounded-md">{t('listHints.collectAndReturnTooltip')}</span>
                            )}
                            {(OrganizationIsArval(props.organization) && PremiumServiceIsReplacementVehicleId(premiumService)) &&(
                                <span className="tooltipContent hidden rounded-md">{t('listHints.replacementVehicleTooltip')}</span>
                            )}
                        </div>
                    </div>
                ))}
        </div>
    );
}


